import React from "react";

import "./loading.css";

import { useSelector } from "react-redux";

import LoadingIcon from "../../../assets/loader/loader.gif";

import { handleHideScrollBar } from "../../../utils/dom";

// function calculateScrollBarWidth() {
//   const windowWidth = window.innerWidth;
//   const documentWidth = document.documentElement.clientWidth;

//   return windowWidth - documentWidth;
// }

const GlobalLoader = () => {
  const loading = useSelector((state) => state?.loading?.isLoading);

  // load the image on mount
  React.useEffect(() => {
    const img = new Image();
    img.src = "/static/media/loader.47b2e8885d631bb5ccca.gif";
  }, []);

  handleHideScrollBar(loading);

  if (!loading) return null;

  return (
    <div className="global-loader">
      <img src={LoadingIcon} alt="loader" />
    </div>
  );
};

export default GlobalLoader;
